export class CustomerDetailUserStateTypes {
    public static readonly GetCollectionChecksByRelationshipRequest =
        'getCollectionChecksByRelationshipRequest';
    public static readonly GetIneligiblesByRelationshipRequest =
        'getIneligiblesByRelationshipRequest';
    public static readonly GetInvoicesByRelationshipRequest = 'getInvoicesByRelationshipRequest';
    public static readonly GetPurchasesByRelationshipRequest = 'getPurchasesByRelationshipRequest';
}
